import { useTeaContext } from '../contexts/tea-context';
import { useFeatureTreatment } from '../hooks/use-feature-treatment';

export default function Feature({
  name,
  children,
}: {
  name: string;
  children: React.ReactNode;
}) {
  const { baseUrl } = useTeaContext();
  const featureTreatment = useFeatureTreatment(baseUrl, name);

  return <>{featureTreatment === 'on' ? children : null}</>;
}
